import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageWSL7 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Rita Guarino New West Ham Manager",
            author: "footballgirl",
            date: "January, 2026",
            image: "images/wsl/7a.jpg",
            content: `<h3>Appointment Announcement</h3>
<p><b>West Ham United</b> have appointed <b>Rita Guarino</b> as their new women's team <b>Head Coach</b>. The experienced Italian coach takes charge immediately as the <b>Hammers</b> look to secure their <b>Barclays Women's Super League (WSL)</b> status amid a challenging season.</p>

<h3>Background and Replacement</h3>
<p><b>Guarino</b> replaces <b>Rehanne Skinner</b>, who was sacked in December 2025 following a poor start that left <b>West Ham</b> 11th in the table with just five points from 11 matches. The 54-year-old <b>Guarino</b>, who signed an <b>18-month contract</b> keeping her in charge until the end of the 2026/27 season, brings a wealth of experience from her native Italy. This marks her first managerial role outside Italy.</p>

<h3>Playing and Early Coaching Career</h3>
<p>A former Italy international striker with <b>99 caps</b> and 35 goals, <b>Guarino</b> represented her country in two <b>FIFA Women's World Cups</b> (1991 and 1999). She made history as the inaugural head coach of <b>Juventus Women</b> in 2017, leading them to four consecutive <b>Serie A Femminile</b> titles, along with multiple domestic cups, establishing the club as a dominant force in Italian women's football.</p>

<h3>Recent Coaching Experience</h3>
<p>After four successful seasons at <b>Juventus</b>, she moved to <b>Inter Milan Women</b> in 2021, where she spent three years building the project and competing at the highest level in Serie A. Following an 18-month break from management, <b>Guarino</b> returns to the dugout with <b>West Ham</b>, tasked with turning around the team's fortunes and avoiding relegation from the <b>WSL</b>.</p>

<h3>Tactical Approach and Early Results</h3>
<p>Since her appointment on 22 December 2025, <b>Guarino</b> has introduced tactical changes, shifting from a previous 4-4-2 setup to more flexible formations, often featuring a back-three base to congest central areas and adapt to opponents. Her first match in charge was an away fixture against defending champions <b>Chelsea</b> on 11 January 2026. Subsequent results have shown efforts to reinvigorate the squad, including a notable win that boosted morale, with the team improving step by step under her guidance.</p>

<h3>Club Reaction and Impact</h3>
<p><b>West Ham's</b> women's team expressed excitement about the appointment, highlighting <b>Guarino's</b> proven track record in player development, tactical innovation, and winning mentality. As the first Italian manager in the <b>Barclays WSL</b>, she is already paving the way for greater diversity in coaching across the league.</p>

<h3>Outlook for the Future</h3>
<p><b>Guarino's</b> arrival is seen as a bold move by the club to inject fresh ideas and stability during a critical phase of the campaign. As of February 2026, <b>West Ham United Women</b> sit in 10th place in the <b>WSL</b> table with 11 points from 16 matches, aiming to climb further up the standings and build for long-term success in English women's football.</p> <h3>任命公告</h3>
<p><b>西汉姆联</b>已任命<b>丽塔·瓜里诺</b>为女子队新任<b>主教练</b>。这位经验丰富的意大利教练立即上任，<b>铁锤帮</b>希望借此确保他们在<b>巴克莱女子超级联赛（WSL）</b>的地位，面对本赛季的严峻挑战。</p>

<h3>背景与接替</h3>
<p><b>瓜里诺</b>接替了<b>雷汉妮·斯金纳</b>，后者因球队在本赛季开局不佳（11场比赛仅积5分，排名第11位）于2025年12月被解雇。这位54岁的<b>瓜里诺</b>签署了一份<b>18个月合同</b>，将执教至2026/27赛季结束，这是她首次在意大利以外执教。</p>

<h3>球员生涯与早期执教</h3>
<p>作为前意大利国家队前锋，<b>瓜里诺</b>为国出战<b>99次</b>，打入35球，曾参加两届<b>国际足联女子世界杯</b>（1991年和1999年）。她在2017年成为<b>尤文图斯女子队</b>的首任主教练，带领球队连续四年夺得<b>意大利女子甲级联赛</b>冠军，并多次赢得国内杯赛，将俱乐部打造成意大利女子足坛的霸主。</p>

<h3>近期执教经历</h3>
<p>在尤文图斯执教四个赛季后，她于2021年转投<b>国际米兰女子队</b>，在那里度过三年，继续在Serie A最高水平竞争。经过18个月的执教空窗期，<b>瓜里诺</b>重返教练席，肩负起扭转西汉姆联颓势、避免降级的重任。</p>

<h3>战术调整与早期表现</h3>
<p>自2025年12月22日上任以来，<b>瓜里诺</b>引入战术变革，从之前的4-4-2阵型转向更灵活的体系，常采用三后卫结构以封堵中路并根据对手调整。她的首场比赛是2026年1月11日客场对阵卫冕冠军<b>切尔西</b>。随后球队在她的带领下展现出重振雄风的努力，包括一场关键胜利提振士气，球队正逐步改善。</p>

<h3>俱乐部反应与影响</h3>
<p><b>西汉姆联</b>女子队对这一任命表示兴奋，强调<b>瓜里诺</b>在球员培养、战术创新和赢球心态方面的出色记录。作为<b>巴克莱WSL</b>首位意大利主教练，她已在推动联赛教练多样性方面发挥作用。</p>

<h3>未来展望</h3>
<p><b>瓜里诺</b>的到来被视为俱乐部在关键时期注入新思路和稳定的大胆举措。截至2026年2月，<b>西汉姆联女子队</b>在<b>WSL</b>积分榜上排名第10位，16场比赛积11分，目标是进一步提升排名并为英格兰女子足球的长远发展奠基。</p>`,
            tags: ["West Ham", "WSL", "Managers"],
            navIndices: { prev: 'wsl-6', next: 'wsl-8' }
        });
    }

    init() {
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to WSL
            
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
`;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'wslnews' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) { leagueLogo.src = '/images/league_wsl.png'; leagueLogo.alt = 'WSL'; }
    }
}